<template>
    <header class="inner">
        <div class="d-sm-block d-md-block d-lg-none">
            <b-carousel id="carousel-fade" controls :interval="0">
                <b-carousel-slide v-for="image in result.hotel.media" :key="image.url">
                    <template v-slot:img>
                        <div
                            class="gallery"
                            v-bind:style="{
                                backgroundImage: 'url(' + image.uri + ')',
                            }"
                        />
                    </template>
                </b-carousel-slide>
                <template v-if="partners">
                    <b-carousel-slide v-for="image in partners.images" :key="image.large">
                        <template v-slot:img>
                            <div
                                class="gallery"
                                v-bind:style="{
                                    backgroundImage: 'url(' + image.large + ')',
                                }"
                            />
                        </template>
                    </b-carousel-slide>
                </template>
            </b-carousel>
        </div>
        <div class="d-none d-md-none d-lg-block">
            <template v-if="partners.images">
                <div class="grid">
                    <div
                        v-for="image in result.hotel.media.slice(0,1)"
                        :key="image.url"
                        class="item"
                        v-bind:style="{
                            backgroundImage: 'url(' + image.uri + ')',
                        }"
                    />
                    <template v-if="partners.images">
                        <div
                            v-for="image in partners.images.slice(1,5)"
                            :key="image.large"
                            class="item"
                            v-bind:style="{
                                backgroundImage: 'url(' + image.large + ')',
                            }"
                        />
                    </template>
                    <template v-else>
                        <div class="item placeholder"/>
                        <div class="item placeholder"/>
                        <div class="item placeholder"/>
                        <div class="item placeholder"/>
                    </template>
                </div>
            </template>
            <template v-else>
                <b-carousel id="carousel-fade" controls :interval="0">
                    <b-carousel-slide v-for="image in result.hotel.media" :key="image.url">
                        <template v-slot:img>
                            <div
                                class="gallery"
                                v-bind:style="{
                                    backgroundImage: 'url(' + image.uri + ')',
                                }"
                            />
                        </template>
                    </b-carousel-slide>
                </b-carousel>
            </template>
        </div>
    </header>
</template>

<script>
    export default {
        name: 'HotelDetailHeader',
        components: {

        },
        props: {
            partners: {
                type: Object,
                required: true
            },
            result: {
                type: Object,
                required: true
            },
        },
    }
</script>

<style scoped>

.gallery,
.placeholder-img {
    height: 100% !important;
    width: 100% !important;
    min-height: 350px;
}


.gallery{
    background-size: cover;
    background-position: 50% 50%;
    background-repeat: no-repeat;
}

.grid {
  display: grid;
  grid-template-rows: 
    repeat(2, 180px);
  grid-template-columns: 
    repeat(5, 1fr);
  grid-gap: 2px;
}

.item:nth-child(1) {
  grid-row: 1 / 3;
  grid-column: 1 / 4;
}

.item:nth-child(2) {
    grid-column: 4;
    grid-row: 1;
}

.item:nth-child(3) {
    grid-column: 5;
    grid-row: 1;
}

.item:nth-child(4) {
    grid-column: 4;
    grid-row: 2;
}

.item:nth-child(5) {
    grid-column: 5;
    grid-row: 2;
}

/* styling code */

.grid > .item {
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
.placeholder{
    background-image: url('~@/assets/placeholder-detail.png');
    background-size: cover;
    background-repeat: repeat;
}
</style>